import React from 'react';
import startCase from 'lodash.startcase';
import { Subtitle2 } from '../../typography';
import { LegendList, StyledLegendListItem } from './styled';
const LegendListItem = (payload) => (React.createElement(StyledLegendListItem, { key: payload.value },
    React.createElement("svg", { viewBox: "0 0 8 8", height: "8" },
        React.createElement("rect", { rx: "2", height: "8", width: "8", fill: payload.color })),
    React.createElement(Subtitle2, null, startCase(payload.value))));
export const Legend = ({ payload, legendPosition }) => (React.createElement(LegendList, { "$justifyContent": legendPosition }, payload === null || payload === void 0 ? void 0 : payload.map(LegendListItem)));
